module.exports = __webpack_public_path__ + "img/scatter.83c23a65.png";